module.exports = __webpack_public_path__ + "static/Vijayan-Bala-bd8f5f36d221b3d10eb052361f0fa15b.png";